import { useState } from "react";

import * as Api from "@/api";
import Valkyrie, { viPlus, viSpinnerThird } from "@sippy-platform/valkyrie";

import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function CreateLineKeyTemplate({ user, lineKeyTemplateAccount, deviceName, dispatch }) {
  const [processing, setProcessing] = useState(false);

  const createLineKeyTemplate = async () => {
    setProcessing(true);

    Promise.resolve(
      Api.getDevice({ type: deviceName === "Primary device" ? (user?.device?.type ?? "SIP-T46U") : "EXP43" }),
    ).then((response) => {
      const lineKeyTemplate = {
        name: `${user.name} ${deviceName}`,
        description: null,
        lineKeys: [],
        preferredDevice: response.data.device,
        preferredDeviceId: response.data.device.id,
      };

      Promise.resolve(Api.postLineKeyTemplate(lineKeyTemplate)).then((_response) => {
        Promise.resolve(Api.getLineKeyTemplates());

        const newLineKeyTemplateAccount = {
          accountId: user.id,
          position: lineKeyTemplateAccount.position,
          templateId: _response.data.lineKeyTemplate.id,
          id: lineKeyTemplateAccount?.id,
        };

        Promise.resolve(Api.postLineKeyTemplateAccount(newLineKeyTemplateAccount))
          .then((__response) => {
            Promise.resolve(Api.getLineKeyTemplate(_response.data.lineKeyTemplate)).then((___response) => {
              dispatch({
                type: "addLineKeyTemplateAccount",
                lineKeyTemplateAccount: {
                  ...newLineKeyTemplateAccount,
                  id: __response.data.lineKeyTemplateAccount.id,
                  template: ___response.data.lineKeyTemplate,
                },
              });

              setProcessing(false);
            });
          })
          .catch(() => {
            setProcessing(false);
          });
      });
    });
  };

  return (
    <ListItemButton onClick={() => createLineKeyTemplate()} disabled={processing} sx={{ minHeight: 44 }}>
      <ListItemIcon sx={{ width: 44 }}>
        <Valkyrie icon={viPlus} />
      </ListItemIcon>
      <ListItemText primary="Create new template" />
      {processing && (
        <ListItemIcon sx={{ minWidth: 16 }}>
          <Valkyrie icon={viSpinnerThird} spin />
        </ListItemIcon>
      )}
    </ListItemButton>
  );
}

CreateLineKeyTemplate.propTypes = {
  lineKeyTemplateAccount: PropTypes.object,
  user: PropTypes.object,
  deviceName: PropTypes.string,
  dispatch: PropTypes.func,
};

export default CreateLineKeyTemplate;
